import styled, { css } from 'styled-components';

export const Wrapper = styled.section<{ $hasCreditCardBanner: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0px 2px;
    margin-top: 8px;
    gap: 0.4rem;
    
    @media (min-width: 1200px) {
        margin-top: 0;
        height: calc(100vh - 100px - 138px - 65px);

        ${({ $hasCreditCardBanner }) => $hasCreditCardBanner && css`
            height: calc(100vh - 100px - 138px - 65px - 82px);
        `}
    }
`;
